import { render } from "./Kids.vue?vue&type=template&id=c7c8c82c"
import script from "./Kids.vue?vue&type=script&lang=js"
export * from "./Kids.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__